export default class CancelBackButton {
	constructor() {
		this.template = require('./jf-cancel-back-button.view.html');
		this.controller = CancelBackButtonController;

		this.bindings = {
			toState      : '<',
			toStateParams: '<'
		};
	}
}

CancelBackButton.META = {
	name: 'cancelBackButton'
};

class CancelBackButtonController {
	constructor($state, appStateService) {
		this.$state = $state;
		this.appStateService = appStateService;
	}

	goBack() {
		let lastState = this.appStateService.getState('lastState');
		this.$state.go(this.toState, _.assign({}, this.toStateParams, {tab: lastState && lastState.params.tab}));
	}
}

CancelBackButtonController.$inject = ['$state', 'AppState'];


// WEBPACK FOOTER //
// ./modules/distribution/directives/jf-cancel-back-button/jf-cancel-back-button.component.js